<template>
  <div>
    <vx-card>
      <h4 class="mb-5">Complete in 3 steps</h4>
      <p>1. Click the button below and complete the external experience</p>
      <p>
        2. Once you’ve completed it, download the ‘certificate of completion’ and come back to this
        page
      </p>
      <p>3. Click the certificate tab and upload your ‘certificate of completion’</p>
      <br />
      <br />
      <a
        v-if="experience"
        role="button"
        :href="experience.vje.cta_link"
        target="_blank"
        aria-label="Continue Nursing experience"
        class="btn btn-primary btn-size-small"
      >
        Let's Begin!
        <feather-icon
          aria-hidden="true"
          class="mr-0 cursor-pointer menu-ctrl pt-1"
          icon="ExternalLinkIcon"
          svg-classes="stroke-width-1 text-gray-400 h-4 w-4"
        />
      </a>
      <p class="my-5">
        <small>*You will be redirected to year13.com.au</small>
      </p>
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType === 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id === parseInt(this.activeExperienceID));
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
  },
  beforeMount() {
    store.commit('authStudent/setActiveExperienceID', this.$route.params.id);
  },
};
</script>
